module.exports = __webpack_public_path__ + "img/swisscom-natelpay.1f0c6a4d.png";